import galastropods from '../../data/galastropods.json';
const getGalastropod = (galastropodId) => galastropods[galastropodId];
const getAllGalastropods = () => {
    const all = [];
    for (const id of Object.keys(galastropods)) {
        all.push(galastropods[id]);
    }
    return all;
};
export { getAllGalastropods, getGalastropod };
